import { Box, FormControl, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { LightTooltip } from '../../../../atoms/Tooltip/LightTooltip';
import theme from '../../../../foundation/theme';
import SearchBar from '../../../../atoms/SearchBar/SearchBar';

const SubHeader = ({ tabs }) => {
  const [value, setValue] = useState([]);
  const navigate = useNavigate();

  const handleChange = (event) => {
    navigate(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', gap: 7 }}>
      <FormControl variant="standard" sx={{ width: 150, border: 0, mt: 1 }}>
        <StyledSelect
          displayEmpty
          value={value}
          onChange={handleChange}
          renderValue={(selected) => {
            if (selected) {
              return (
                <LightTooltip
                  title={'Feedback'}
                  placement="bottom-end"
                  arrow
                  bgColor="#212B36"
                  color={theme.palette.neutral.light60}
                  sx={{ margin: 2 }}
                  enterDelay={500}
                >
                  {'Feedback'}
                </LightTooltip>
              );
            }
          }}
        >
          {tabs.map((item) => {
            const { name, label, path } = item;
            return (
              <MenuItem key={name} value={path}>
                {label}
              </MenuItem>
            );
          })}
        </StyledSelect>
      </FormControl>

      <SearchBar />
    </Box>
  );
};

export default SubHeader;

const StyledSelect = styled(Select)`
  height: 36px;
  &.MuiInput-underline:before,
  &.MuiInput-underline:after {
    display: none;
  }
`;
